import React from 'react';
import { getComputedCSSVariable } from '../../utils/cssVariableHelpers';

interface Props {
  color?: string,
  style?: object,
}

const FlagEmptySVG: React.FC<Props> = ({
  color,
  style,
}) => {
  return (
    <div
      className="d-flex svg-wrapper"
      style={style}
    >
      <svg height="100px" width="100px" fill={color} xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 100 100" x="0px" y="0px">
        <path d="M79,17.49a7,7,0,0,0-4.8-12.1H21.81a3,3,0,0,0-3,3V91.61a3,3,0,0,0,6,0V56.48H74.19A7,7,0,0,0,79,44.38L65.48,31.66a1,1,0,0,1,0-1.46Z" />
      </svg>
    </div>
  );
};

FlagEmptySVG.defaultProps = {
  color: getComputedCSSVariable('warning'),
  style: {
    width: '15px',
    height: '15px',
  },
};

export default FlagEmptySVG;
